import React from 'react';
import ModalTemplate from '../ModalTemplate';
import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';

const ForBetterExpModal = ({ isOpen, onClose, onContinue }: { isOpen: boolean; onClose: () => void; onContinue: () => void }) => {
	return (
		<ModalTemplate marginX={4} isOpen={isOpen} onClose={onClose} showCloseButtonIcon={true} closeOnEsc={true} closeOnOverlayClick={true}>
			<Box textAlign="center">
				<Image src="/images/devices.svg" alt="image" mx="auto" />
				<Text mt="10px" textStyle="h4" color="#4358F6">
					Switch to a desktop/laptop for a better experience.
				</Text>
				<Text textStyle="body1-md" color="#3B3435" mt="10px">
					Once you start the assessment, you won't be able to start it again on any device.
				</Text>
				<Flex justifyContent="center" mt="24px" gap="16px">
					<Button variant="secondary" onClick={onClose}>
						cancel
					</Button>
					<Button variant="primary" onClick={onContinue}>
						Continue
					</Button>
				</Flex>
			</Box>
		</ModalTemplate>
	);
};

export default ForBetterExpModal;
